export interface SamplerBindingSpec {
  name: string;
  textureUnit: number;
}

export interface ResolvedSamplerBinding extends SamplerBindingSpec {
  location: WebGLUniformLocation;
}

export function createMainSamplerBindings(count: number): SamplerBindingSpec[] {
  const bindings: SamplerBindingSpec[] = [];

  for (let i = 0; i < count; i++) {
    bindings.push({
      name: `uSampler${i}`,
      textureUnit: i
    });
  }

  return bindings;
}

export function createRegionMaskSamplerBindings(mainSamplerCount: number): SamplerBindingSpec[] {
  return [
    { name: 'uBaseTexture', textureUnit: mainSamplerCount },
    { name: 'uRegionMask', textureUnit: mainSamplerCount + 1 }
  ];
}
